/* ==========================================================================
   Ambury bundle builder - sections/wqs-bundle-builder.liquid

   Cards are server-rendered; this file keeps the picks (saved in
   localStorage so a visit to a product page never loses progress), toggles
   card state, draws the tray / mobile sticky bar / details drawer, and adds
   the bundle to the cart drawer.

   Pre-fill links: ?scent=<handle> or ?set=<trio key>, applied once and then
   stripped from the URL (UTMs kept).
   ========================================================================== */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.bbReady) return;
    root.dataset.bbReady = '1';

    var $ = function (sel) { return root.querySelector(sel); };
    var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

    var cfg = {};
    try { cfg = JSON.parse($('[data-bb-config]').textContent); } catch (e) {}

    /* --- scents and trios from the markup ------------------------------- */
    var BY = {};
    var cards = $$('.bb-card');
    cards.forEach(function (card) {
      try {
        var s = JSON.parse(card.querySelector('[data-bb-scent]').textContent);
        s.card = card;
        BY[s.h] = s;
      } catch (e) {}
    });
    var SETS = {};
    $$('[data-set]').forEach(function (b) {
      SETS[b.dataset.set] = { n: b.dataset.setName, s: b.dataset.setHandles.split(',') };
    });

    var KEY = root.dataset.storageKey || 'ambury_rotation';
    var picks = [];
    /* The opening tab is set in the theme editor and marked in the markup */
    var startTab = root.querySelector('.bb-tab.is-on');
    var filter = startTab ? startTab.dataset.f : 'all';
    var query = '';
    var current = null;
    var mOpen = false;
    var lastFocus = null;

    try {
      var saved = JSON.parse(localStorage.getItem(KEY) || '[]');
      if (Array.isArray(saved)) picks = saved.filter(function (h) { return BY[h] && BY[h].ok; }).slice(0, 3);
    } catch (e) {}

    function save() { try { localStorage.setItem(KEY, JSON.stringify(picks)); } catch (e) {} }
    function count(h) { return picks.filter(function (x) { return x === h; }).length; }
    function isFull() { return picks.length >= 3; }
    function esc(t) {
      return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function money(cents) {
      var v = cents / 100;
      return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
    }

    var toastEl = $('[data-bb-toast]');
    function toast(t) {
      toastEl.textContent = t;
      toastEl.classList.add('is-on');
      clearTimeout(toastEl._t);
      toastEl._t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3200);
    }

    /* --- sticky offset: sit the tabs / tray just under the sticky header --- */
    var filters = $('[data-bb-filters]');
    function measureHeader() {
      var top = 0;
      var group = document.querySelectorAll('.shopify-section-group-header-group');
      Array.prototype.forEach.call(group, function (el) {
        /* Where the header rests once stuck (its `top` plus its height), not
           where it sits now - the announcement bar above it scrolls away. */
        var cs = getComputedStyle(el);
        if (cs.position === 'sticky' || cs.position === 'fixed') {
          top = Math.max(top, (parseFloat(cs.top) || 0) + el.offsetHeight);
        }
      });
      root.style.setProperty('--bb-sticky-top', Math.max(0, Math.round(top)) + 'px');
    }
    measureHeader();
    var rafPending = false;
    window.addEventListener('resize', function () {
      if (rafPending) return;
      rafPending = true;
      requestAnimationFrame(function () { rafPending = false; measureHeader(); });
    }, { passive: true });
    if ('IntersectionObserver' in window && filters) {
      var sentinel = document.createElement('div');
      sentinel.setAttribute('aria-hidden', 'true');
      filters.parentNode.insertBefore(sentinel, filters);
      new IntersectionObserver(function (entries) {
        filters.classList.toggle('is-stuck', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      }, { rootMargin: '-' + (parseInt(getComputedStyle(root).getPropertyValue('--bb-sticky-top'), 10) || 0) + 'px 0px 0px 0px' }).observe(sentinel);
    }

    /* --- grid ------------------------------------------------------------ */
    /* --- on-page search: matches the inspired-by house/name and the scent */
    function norm(t) {
      return String(t || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
    }
    cards.forEach(function (card) {
      var s = BY[card.dataset.handle] || {};
      card._hay = ' ' + norm([s.b, s.i, s.n].join(' ')) + ' ';
    });
    function matchesQuery(card) {
      if (!query) return true;
      return query.split(' ').every(function (w) { return card._hay.indexOf(w) !== -1; });
    }
    function inTab(card) {
      if (filter === 'all') return true;
      if (filter === 'best') return card.dataset.best === 'true';
      if (filter.indexOf('c:') === 0) return (card.dataset.colls || '').indexOf(',' + filter.slice(2) + ',') !== -1;
      return card.dataset.gender === filter;
    }

    function renderGrid() {
      var full = isFull();
      var shown = 0;
      cards.forEach(function (card) {
        var h = card.dataset.handle;
        var s = BY[h];
        var match = inTab(card) && matchesQuery(card);
        card.classList.toggle('is-hidden', !match);
        if (match) shown++;
        var c = count(h);
        card.classList.toggle('is-in', c > 0);
        card.querySelector('[data-bb-badge]').textContent = 'In bundle' + (c > 1 ? ' ×' + c : '');
        var add = card.querySelector('.bb-add');
        if (!s || !s.ok) return;
        add.disabled = full;
        add.textContent = full ? cfg.fullLabel : cfg.addLabel;
      });
      var cnt = $('[data-bb-count]');
      if (cnt) cnt.textContent = shown + ' scents';
      var none = $('[data-bb-noresults]');
      if (none) {
        none.hidden = shown > 0 || !query;
        $('[data-bb-noresults-text]').textContent = cfg.noResults || 'No scents match your search.';
      }
    }

    function setTab(f) {
      filter = f;
      $$('.bb-tab').forEach(function (x) {
        var on = x.dataset.f === f;
        x.classList.toggle('is-on', on);
        x.setAttribute('aria-selected', String(on));
      });
    }

    var searchInput = $('[data-bb-search]');
    function setQuery(raw) {
      query = norm(raw);
      $$('.bb-search__clear').forEach(function (b) { b.hidden = !raw; });
      /* A search looks across every scent, not just the open tab */
      if (query && filter !== 'all') setTab('all');
      renderGrid();
    }
    if (searchInput) {
      searchInput.addEventListener('input', function () { setQuery(searchInput.value); });
      searchInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); searchInput.blur(); }
      });
    }
    function clearSearch() {
      if (searchInput) searchInput.value = '';
      setQuery('');
    }

    /* Header search icon: use this page's search instead of the store search,
       so shoppers stay here. Capture phase runs before the store's handler. */
    if (cfg.searchHeader && searchInput) {
      document.addEventListener('click', function (e) {
        var trig = e.target.closest && e.target.closest('[data-ambury-search-open]');
        if (!trig || root.contains(trig)) return;
        e.preventDefault();
        e.stopPropagation();
        searchInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
        searchInput.focus({ preventScroll: true });
      }, true);
    }

    /* Mobile tabs scroll sideways: fade the edge while more tabs are hidden */
    function tabsFade() {
      if (!filters) return;
      filters.classList.toggle('has-more', filters.scrollLeft + filters.clientWidth < filters.scrollWidth - 4);
    }
    if (filters) {
      filters.addEventListener('scroll', tabsFade, { passive: true });
      window.addEventListener('resize', tabsFade, { passive: true });
      tabsFade();
    }

    /* --- tray / sticky bar ----------------------------------------------- */
    function regular() { return picks.reduce(function (t, h) { return t + BY[h].p; }, 0); }

    function ctaText() {
      var l = 3 - picks.length;
      return l === 3 ? 'Pick 3 scents' : l > 0 ? 'Pick ' + l + ' more' : 'Add bundle to cart · ' + cfg.priceLabel;
    }

    function slotsHTML() {
      return [0, 1, 2].map(function (i) {
        var h = picks[i];
        if (!h) return '<div class="bb-slot"><span class="bb-slot__n">' + (i + 1) + '</span><span class="bb-slot__empty">Pick a scent</span></div>';
        var s = BY[h];
        return '<div class="bb-slot is-filled">' +
          (s.thumb ? '<img src="' + esc(s.thumb) + '" alt="" width="44" height="44">' : '') +
          '<div class="bb-slot__nm">' + esc(s.n) + (s.b || s.i ? '<small>Inspired by ' + esc(s.b) + ' ' + esc(s.i) + '</small>' : '') + '</div>' +
          '<button type="button" class="bb-slot__x" data-rm="' + i + '" aria-label="Remove ' + esc(s.n) + '">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button></div>';
      }).join('');
    }

    function renderTray() {
      var full = isFull();
      var reg = regular();
      var sv = reg - cfg.price;

      var slots = slotsHTML();
      $('[data-bb-slots]').innerHTML = slots;
      $('[data-bb-mpanel]').innerHTML = slots;

      $('[data-bb-price]').innerHTML = !full
        ? '<span class="bb-price__idle">' + esc(cfg.priceIdle) + '</span>'
        : (sv > 0 ? '<span class="bb-price__was">' + money(reg) + '</span>' : '') +
          '<span class="bb-price__now">' + cfg.priceLabel + '</span>' +
          (sv > 0 ? '<span class="bb-price__save">You save ' + money(sv) + '</span>' : '');

      $('[data-bb-mprice]').innerHTML = !full
        ? '<b>' + esc(cfg.priceIdle) + '</b>'
        : (sv > 0 ? '<span class="bb-price__was">' + money(reg) + '</span> ' : '') +
          '<b>' + cfg.priceLabel + '</b>' +
          (sv > 0 ? '<span class="bb-mprice__sv">Save ' + money(sv) + '</span>' : '');

      $('[data-bb-mslots]').innerHTML = [0, 1, 2].map(function (i) {
        var s = BY[picks[i]];
        return s ? '<i class="is-f">' + (s.thumb ? '<img src="' + esc(s.thumb) + '" alt="">' : '') + '</i>' : '<i>' + (i + 1) + '</i>';
      }).join('');

      /* Under 3 picks the button guides to the scents rather than sitting disabled */
      $$('[data-bb-cta]').forEach(function (b) {
        b.disabled = false;
        b.classList.toggle('is-guide', !full);
        b.textContent = ctaText();
      });

      /* Fix 1: the full message is shown once - tray and sticky bar only */
      $('[data-bb-full-note]').hidden = !full;
      $('[data-bb-mfull]').hidden = !full;

      var one = $('[data-bb-one]');
      one.hidden = !picks.length;
      if (picks[0]) one.href = BY[picks[0]].url;

      $('[data-bb-mreview]').hidden = !picks.length || mOpen;
      if (!picks.length && mOpen) setMobileOpen(false);
      if (typeof updateMbar === 'function') updateMbar();
    }

    function render() { renderGrid(); renderTray(); save(); }

    /* --- mobile sticky bar open / close ---------------------------------- */
    var mbar = $('[data-bb-mbar]');
    var mscrim = $('[data-bb-mscrim]');
    var mtoggle = $('[data-bb-mtoggle]');
    /* Keep the sticky bar out of the way on arrival: it slides up once the
       shopper reaches the scents, or as soon as they add one. */
    var builderEl = $('.bb-builder');
    var mbarShown = null;
    function updateMbar() {
      if (!mbar) return;
      var reached = builderEl && builderEl.getBoundingClientRect().top < window.innerHeight * 0.55;
      var show = picks.length > 0 || !!reached;
      if (show === mbarShown) return;
      mbarShown = show;
      mbar.classList.toggle('is-away', !show);
      if (!show && mOpen) setMobileOpen(false);
    }
    var mbarTick = false;
    window.addEventListener('scroll', function () {
      if (mbarTick) return;
      mbarTick = true;
      requestAnimationFrame(function () { mbarTick = false; updateMbar(); });
    }, { passive: true });

    /* Scroll to the first scent in view, just under the sticky tabs */
    function scrollToScents() {
      if (mOpen) setMobileOpen(false);
      var grid = $('[data-bb-grid]');
      if (!grid) return;
      var first = grid.querySelector('.bb-card:not(.is-hidden)') || grid;
      var stickTop = parseInt(getComputedStyle(root).getPropertyValue('--bb-sticky-top'), 10) || 0;
      var y = first.getBoundingClientRect().top + window.pageYOffset - stickTop - (filters ? filters.offsetHeight : 0) - 12;
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    }

    function setMobileOpen(open) {
      mOpen = open;
      mbar.classList.toggle('is-open', open);
      mscrim.classList.toggle('is-on', open);
      mtoggle.setAttribute('aria-expanded', String(open));
      $('[data-bb-mtoggle-label]').textContent = open ? 'Close' : (cfg.reviewLabel || 'Edit picks');
      $('[data-bb-mreview]').hidden = open || !picks.length;
      if (open) mtoggle.focus({ preventScroll: true });
    }

    /* --- actions ---------------------------------------------------------- */
    function add(h, silent) {
      var s = BY[h];
      if (!s || !s.ok) return false;
      if (isFull()) { toast(cfg.fullMessage); return false; }
      picks.push(h);
      render();
      if (!silent && window.innerWidth <= 820) toast(s.n + ' is in your bundle.');
      return true;
    }

    var confirmEl = $('[data-bb-confirm]');
    function applySet(k, ask) {
      var p = SETS[k];
      if (!p) return;
      var list = p.s.filter(function (h) { return BY[h] && BY[h].ok; });
      if (list.length < 3) { toast('One of these scents is sold out right now.'); return; }
      var go = function () { picks = list.slice(0, 3); render(); toast(p.n + ' is in your bundle.'); };
      if (ask && picks.length) {
        $('[data-bb-confirm-text]').textContent = 'This swaps your picks for ' + p.n + '. You can still change any slot.';
        confirmEl.classList.add('is-on');
        $('[data-bb-confirm-yes]').onclick = function () { confirmEl.classList.remove('is-on'); go(); };
        $('[data-bb-confirm-yes]').focus();
        return;
      }
      go();
    }

    /* --- details drawer --------------------------------------------------- */
    var drawer = $('[data-bb-drawer]');
    var scrim = $('[data-bb-scrim]');
    function openDetail(h, trigger) {
      var s = BY[h];
      if (!s) return;
      current = h;
      lastFocus = trigger || document.activeElement;
      var rows = [['Top', s.top], ['Heart', s.heart], ['Base', s.base]].filter(function (r) { return r[1]; });
      if (!rows.length && s.a) rows = [['Family', s.a]];
      $('[data-bb-dbody]').innerHTML =
        (s.img ? '<div class="bb-drawer__big"><img src="' + esc(s.img) + '" alt="' + esc(s.n) + '"></div>' : '') +
        (s.gl ? '<span class="bb-tag bb-tag--' + esc(s.g) + '">' + esc(s.gl) + '</span>' : '') +
        '<h3>' + esc(s.n) + '</h3>' +
        (s.b || s.i ? '<p class="bb-drawer__insp">Inspired by <b>' + esc(s.b) + '</b> ' + esc(s.i) + '</p>' : '') +
        (rows.length ? '<div class="bb-notes">' + rows.map(function (r) { return '<div><span>' + r[0] + '</span><span>' + esc(r[1]) + '</span></div>'; }).join('') + '</div>' : '') +
        (s.d ? '<p class="bb-drawer__desc">' + esc(s.d) + '</p>' : '') +
        '<p class="bb-drawer__desc" style="font-size:12px">Full-size 50 mL eau de parfum.</p>';
      var full = isFull();
      var c = count(h);
      var b = $('[data-bb-dadd]');
      b.disabled = full || !s.ok;
      b.textContent = !s.ok ? 'Sold out' : full ? cfg.fullLabel : c ? 'Add another (in bundle ×' + c + ')' : 'Add to bundle';
      $('[data-bb-dpdp]').href = s.url;
      scrim.classList.add('is-on');
      drawer.classList.add('is-on');
      document.documentElement.style.overflow = 'hidden';
      setTimeout(function () { drawer.focus({ preventScroll: true }); }, 50);
    }
    function closeDetail() {
      if (!drawer.classList.contains('is-on')) return;
      scrim.classList.remove('is-on');
      drawer.classList.remove('is-on');
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }

    /* --- add bundle to cart ----------------------------------------------- */
    function addBundle(btn) {
      if (!isFull() || btn.classList.contains('is-loading')) return;
      var items;
      if (cfg.cartMode === 'bundle_product' && cfg.bundleVariant) {
        /* One line: this $89 product, the picks as "Scent 1/2/3" properties.
           Simple Bundles (infinite options) matches these names and values to
           its option groups and adds the 3 scents to the order at $0. */
        var bprops = { _bundle_page: root.dataset.bundleUrl };
        picks.forEach(function (h, i) { bprops[(cfg.propertyPrefix || 'Scent') + ' ' + (i + 1)] = BY[h].n; });
        items = [{ id: cfg.bundleVariant, quantity: 1, properties: bprops }];
      } else {
        var bid = Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
        var props = {
          Bundle: cfg.bundleName,
          _bundle_id: bid,
          _bundle_page: root.dataset.bundleUrl
        };
        var qty = {};
        picks.forEach(function (h) { qty[h] = (qty[h] || 0) + 1; });
        items = Object.keys(qty).map(function (h) {
          return { id: BY[h].id, quantity: qty[h], properties: props };
        });
      }
      var cartDrawer = document.querySelector('cart-drawer');
      var body = { items: items };
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        body.sections = 'cart-drawer,cart-icon-bubble';
        body.sections_url = window.location.pathname;
      }
      $$('[data-bb-cta]').forEach(function (b) { b.classList.add('is-loading'); });
      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j.description || res.j.message || 'Could not add to cart');
          picks = [];
          setMobileOpen(false);
          render();
          if (body.sections && res.j.sections) {
            cartDrawer.classList.remove('is-empty');
            cartDrawer.renderContents(res.j);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function (err) { toast(err.message); })
        .then(function () { $$('[data-bb-cta]').forEach(function (b) { b.classList.remove('is-loading'); }); });
    }

    /* --- events ----------------------------------------------------------- */
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-add],[data-det],[data-rm],[data-set],[data-bb-close],.bb-tab,[data-bb-cta],[data-bb-reviews-link],[data-bb-search-clear],.bb-slot');
      if (!t || !root.contains(t)) return;
      if (t.dataset.add) add(t.dataset.add);
      else if (t.dataset.det) openDetail(t.dataset.det, t);
      else if (t.dataset.rm !== undefined) { picks.splice(+t.dataset.rm, 1); render(); }
      else if (t.dataset.set) applySet(t.dataset.set, true);
      else if (t.hasAttribute('data-bb-close')) closeDetail();
      else if (t.hasAttribute('data-bb-cta')) { if (isFull()) addBundle(t); else scrollToScents(); }
      else if (t.classList.contains('bb-slot')) { if (!t.classList.contains('is-filled')) scrollToScents(); }
      else if (t.hasAttribute('data-bb-reviews-link')) {
        var rv = document.querySelector('[id$="__bundle_reviews"], .section-customer-reviews');
        if (rv) { e.preventDefault(); rv.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      } else if (t.hasAttribute('data-bb-search-clear')) {
        clearSearch();
        if (searchInput) searchInput.focus();
      } else if (t.classList.contains('bb-tab')) {
        setTab(t.dataset.f);
        /* Picking a tab starts a fresh browse */
        if (query) { if (searchInput) searchInput.value = ''; query = ''; $$('.bb-search__clear').forEach(function (b) { b.hidden = true; }); }
        renderGrid();
        /* Keep the first row in view when the user switches deep in the grid */
        var gridTop = $('[data-bb-grid]').getBoundingClientRect().top;
        var stickTop = filters.getBoundingClientRect().bottom;
        if (gridTop < stickTop) window.scrollBy({ top: gridTop - stickTop - 8, behavior: 'smooth' });
      }
    });

    $('[data-bb-dadd]').addEventListener('click', function () {
      var h = current;
      if (add(h, true)) { closeDetail(); toast(BY[h].n + ' is in your bundle.'); }
    });
    scrim.addEventListener('click', closeDetail);
    $('[data-bb-confirm-no]').addEventListener('click', function () { confirmEl.classList.remove('is-on'); });
    mtoggle.addEventListener('click', function () { setMobileOpen(!mOpen); });
    $('[data-bb-mreview]').addEventListener('click', function () { setMobileOpen(true); });
    $('[data-bb-mslots]').addEventListener('click', function (e) {
      var slot = e.target.closest('i');
      if (slot && slot.classList.contains('is-f')) setMobileOpen(true);
      else scrollToScents();
    });
    mscrim.addEventListener('click', function () { setMobileOpen(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (confirmEl.classList.contains('is-on')) confirmEl.classList.remove('is-on');
      else if (drawer.classList.contains('is-on')) closeDetail();
      else if (mOpen) setMobileOpen(false);
    });

    /* "Want to add another bundle?" in the cart drawer: on this page, close
       the drawer and bring the builder back instead of reloading. */
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-ambury-bundle-again]');
      if (!a) return;
      var url;
      try { url = new URL(a.href, window.location.origin); } catch (err) { return; }
      if (url.pathname !== window.location.pathname) return;
      e.preventDefault();
      var cd = document.querySelector('cart-drawer');
      if (cd && typeof cd.close === 'function') cd.close();
      var target = $('.bb-presets') || filters;
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    /* --- pre-fill links --------------------------------------------------- */
    (function () {
      var u;
      try { u = new URL(window.location.href); } catch (e) { return; }
      var sc = u.searchParams.get('scent');
      var st = u.searchParams.get('set');
      if (st && SETS[st]) applySet(st, false);
      else if (sc && BY[sc]) {
        if (isFull()) toast(cfg.fullMessage);
        else if (add(sc, true)) toast(BY[sc].n + ' is in your bundle.');
      }
      if (sc || st) {
        u.searchParams.delete('scent');
        u.searchParams.delete('set');
        try { history.replaceState(history.state, '', u.pathname + u.search + u.hash); } catch (e) {}
      }
    })();

    render();
  }

  function boot() { document.querySelectorAll('[data-bundle-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
